import React from 'react';
import { Form } from '@8base-react/forms';
import { Dialog, Button, Paragraph, useModal } from '@8base/boost';
import { Mutation } from 'react-apollo';

import { i18n } from 'i18n';
import { TOAST_SUCCESS_MESSAGE } from 'common/constants/apolloOperationContextOptions';
import { ENVIRONMENT_VARIABLE_DELETE_MUTATION } from 'graphql/mutations';

const DIALOG_ID = 'ENVIRONMENT_VARIABLE_DELETE_DIALOG';

const EnvironmentVariableDeleteDialog = () => {
  const { closeModal } = useModal();
  return (
    <Mutation
      mutation={ ENVIRONMENT_VARIABLE_DELETE_MUTATION }
      refetchQueries={ ['EnvironmentVariablesList'] }
      context={{
        [TOAST_SUCCESS_MESSAGE]: i18n.t('settings.environmentVariables.deleteSuccessfull'),
      }}
    >
      { (deleteEnvironmentVariable) => (
        <Dialog
          id={ DIALOG_ID }
          size="sm"
          onClose={ () => closeModal(DIALOG_ID) }
          { ...E2E.$props('settings.environmentVariables.deleteDialog.body') }
        >
          { ({ args }) => (
            <Form onSubmit={ async () => {
              await deleteEnvironmentVariable({ variables: { id: args.id }});
              closeModal(DIALOG_ID);

              window.trackEvent('Environment Variables', 'Delete variable');
            } }>
              { ({ handleSubmit, invalid, submitting }) => (
                <form onSubmit={ handleSubmit }>
                  <Dialog.Header title={ i18n.t('settings.environmentVariables.deleteDialogTitle') } onClose={ () => closeModal(DIALOG_ID) } />
                  <Dialog.Body>
                    <Paragraph>Are you really want to delete this environment variable?</Paragraph>
                  </Dialog.Body>
                  <Dialog.Footer>
                    <Button
                      color="neutral"
                      variant="outlined"
                      disabled={ submitting }
                      onClick={ () => closeModal(DIALOG_ID) }
                      { ...E2E.$props('settings.environmentVariables.deleteDialog.cancelButton') }
                    >
                      { i18n.t('shared.cancel') }
                    </Button>
                    <Button
                      color="danger"
                      type="submit"
                      disabled={ invalid } loading={ submitting }
                      { ...E2E.$props('settings.environmentVariables.deleteDialog.submitButton') }
                    >
                      { i18n.t('shared.delete') }
                    </Button>
                  </Dialog.Footer>
                </form>
              ) }
            </Form>
          ) }
        </Dialog>
      ) }
    </Mutation>
  );
};

EnvironmentVariableDeleteDialog.ID = DIALOG_ID;

export { EnvironmentVariableDeleteDialog };
